module.exports = __webpack_public_path__ + "static/media/forcesActingOnParticle2.8ca48a9c.svg";